function TecnicosFilters({ searchTerm, onSearchTermChange }) {
    return (
        <section className="mb-6 sm:mb-8">
            <label className="block">
                <div className="flex items-center rounded-lg border border-white/10 bg-white/5 px-3 py-3 sm:py-2 focus-within:border-green-500/60 transition-colors">
                    <span className="text-slate-400 mr-2 shrink-0">
                        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                            <circle cx="11" cy="11" r="8" />
                            <path d="m21 21-4.3-4.3" />
                        </svg>
                    </span>
                    <input
                        type="text"
                        value={searchTerm}
                        onChange={(event) => onSearchTermChange(event.target.value)}
                        placeholder="Buscar por nombre o nacionalidad..."
                        className="w-full bg-transparent text-sm sm:text-base text-slate-100 placeholder:text-slate-500 focus:outline-none"
                    />
                    {searchTerm && (
                        <button
                            type="button"
                            onClick={() => onSearchTermChange("")}
                            className="ml-2 p-1 text-slate-400 hover:text-slate-200 active:text-slate-200 transition-colors shrink-0"
                            aria-label="Limpiar búsqueda"
                        >
                            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                                <path d="M18 6 6 18M6 6l12 12" />
                            </svg>
                        </button>
                    )}
                </div>
            </label>
        </section>
    );
}

export default TecnicosFilters;
